module.exports = __webpack_public_path__ + "img/rule-5.fe8a8ea1.png";